import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const ClearHistoryModal = ({ showClearHistoryModal, closeModal, clearTradeHistory }) => {
  return (
    <Modal show={showClearHistoryModal} onHide={closeModal} className="trade-history-modal">
      <Modal.Header closeButton>
        <Modal.Title>Clear Trade History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>This action will <b>permanently</b> delete all historic trade records. Are you sure you want to do this?</p>
        <Button
          onClick={clearTradeHistory}
          className="btn-red add"
          bsStyle="danger"
        >Clear Trade History</Button>
      </Modal.Body>
      <Modal.Footer>
        <Button
          bsStyle="default"
          onClick={closeModal}
        >Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ClearHistoryModal;